import React from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import { useMyTasks } from 'hooks/UseMyTasks';

import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { MyTaskTable } from 'components/MyTaskArea/MyTaskTable/MyTaskTable';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './MyTaskListPage.sass';

const MyTaskListPageEditConfig = {
  emptyLabel: 'My Task List Page',
  isEmpty(props) {
    return !props;
  },
};

export const MyTaskListPage = (props) => {
  const isEditor = Utils.isInEditor();
  const { tasks, isLoading } = useMyTasks({ skip: isEditor });

  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="MyTaskListPage" />;
  }

  return (
    <div className="my-task-list-page">
      <SubTitle text="Meine Aufgaben" notFramed />

      <span>
        Hier finden Sie eine Übersicht aller aktuell laufenden Vorgänge, sowie noch offenen
        Aufgaben.
      </span>

      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <div className="my-task-list-page__content">
          <MyTaskTable taskList={tasks} />
        </div>
      )}
    </div>
  );
};

MapTo('e-fix/components/content/mytasklistpage')(MyTaskListPage, MyTaskListPageEditConfig);
